import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToasterComponent from 'shared/components/ToasterComponent';

import Parameters from 'surface_mount_carriers/components/Parameters';
import Pricing from 'surface_mount_carriers/components/Pricing';
import { selectDataForApp } from 'surface_mount_carriers/store/selectors';
import { changeParameter, validator } from 'surface_mount_carriers/store/slice';
import { doQuote } from 'surface_mount_carriers/store/thunks';

const App = () => {
  // eslint-disable-next-line no-unused-vars
  const { validatorFlag, parameters, quote } = useSelector(selectDataForApp);
  const dispatch = useDispatch();

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
    dispatch(doQuote({ name, value }));
  };

  return (
    <div className="container-fluid container-lg pt-4 pt-xl-0">
      <ToasterComponent />
      <div className="row">
        <div className="col-lg-4">
          <div className="first-section">
            <div className="card parameters">
              <div className="card-body">
                <Parameters
                  parameters={parameters}
                  onChangeParameter={onChangeParameter}
                  validator={validator} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="second-section">
            <div className="container">
              <Pricing parameters={parameters} quote={quote} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;